/**
 * Shuffles the elements of an array using the Fisher-Yates shuffle algorithm.
 *
 * @template T - The type of elements in the array
 * @param array - A readonly array of elements to shuffle
 * @returns A new array containing the same elements in random order
 *
 * @example
 * ```typescript
 * const numbers = [1, 2, 3, 4, 5];
 * const shuffled = shuffleArray(numbers);
 * console.log(shuffled); // e.g., [3, 1, 5, 2, 4]
 * ```
 */
export const shuffleArray = <T>(array: ReadonlyArray<T>): Array<T> => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};
